import axios from 'axios';
import store from '@/store';
import { BUSINESS_INFO_URL, CLIENT_URL } from '@/config';

const getBusinessInfo = () => axios.get(`${BUSINESS_INFO_URL}/${store.state.auth.businessId}`);

const getClients = string => axios.get(CLIENT_URL, {
  params: {
    search_text: string,
  },
});

const addClient = client => axios.post(CLIENT_URL, client);

const getClientById = id => axios.get(CLIENT_URL, {
  params: {
    id,
  },
});

export {
  getBusinessInfo,
  getClients,
  addClient,
  getClientById,
};



// WEBPACK FOOTER //
// ./src/services/business.js